import update from 'immutability-helper';

import * as types from './constants';

const emptyState = {
  items: [
  ],
  editing: true,
  allow_other_items: false,
};

const initialState = window.initial_sponsored_registry_data ?
                      window.initial_sponsored_registry_data : emptyState;

function sponsoredRegistryReducer(state=initialState, action) {

  switch (action.type) {
    case types.UPDATE_SPONSORED_REGISTRY:
      return update(state, {$set: action.sponsoredRegistry});

    default:
      return state;
  }
}

export default sponsoredRegistryReducer;



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/sponsored-registry/reducers.es6